import { ManageAccounts, Cancel } from '@mui/icons-material';
import { deepPurple } from '@mui/material/colors';
import { useState } from 'react';
import { Button, Modal, Box, CircularProgress, Typography, Grid, Autocomplete, Select, MenuItem, Checkbox, TextField } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const UpdateCustomerTasklistRecord = ({ customerTasklist, customerNameOptions, taskNameOptions, customerTasklistStatusList }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [updateClientName, setUpdateClientName] = useState(customerTasklist.clientName ? customerTasklist.clientName : '');
    const [updateTaskName, setUpdateTaskName] = useState(customerTasklist.taskName ? customerTasklist.taskName : '');
    const [updateTaskNumber, setUpdateTaskNumber] = useState(customerTasklist.taskNumber);
    const [updateCustomerTaskStatusID, setUpdateCustomerTaskStatusID] = useState(customerTasklist.statusID);
    const [updateIsPackage, setUpdateIsPackage] = useState(customerTasklist.isPackage);

    const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
    const [updateCustomerTasklistLoading, setUpdateCustomerTasklistLoading] = useState(false);

    //fetch Non Payment Date end
    const submitInsertTasklist = async () => {
        setUpdateBtnDisabled(true);
        setTimeout(() => {
            setUpdateBtnDisabled(false);
        }, 3000);
        setUpdateCustomerTasklistLoading(true);
        try {
            const res = await axiosInstance.put(
                '/CustomerTasklist',
                {
                    id: customerTasklist.id,
                    clientName: updateClientName,
                    taskName: updateTaskName,
                    taskNumber: parseFloat(updateTaskNumber),
                    statusID: parseFloat(updateCustomerTaskStatusID),
                    isPackage: updateIsPackage
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('Customer Tasklist inserted successfully.');
                fetchCustomerTasklistRecord();
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateCustomerTasklistLoading(false);
        }
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ManageAccounts />
            </Button>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {updateCustomerTasklistLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box sx={style}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography id="modal-modal-title" variant="h3" component="h2">
                                Update Customer Tasklist
                            </Typography>
                            <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                        </Box>
                        <Box
                            id="modal-modal-description"
                            sx={{
                                height: '450px',
                                overflowY: 'auto'
                            }}
                        >
                            <Grid item container xs={12} sx={{ mt: 2 }}>
                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Client Name :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={updateClientName}
                                            onChange={(event, newValue) => {
                                                setUpdateClientName(newValue);
                                            }}
                                            inputValue={updateClientName}
                                            onInputChange={(event, newInputValue) => {
                                                setUpdateClientName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={customerNameOptions}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Task Code :
                                        </Typography>
                                        <Autocomplete
                                            freeSolo
                                            value={updateTaskName}
                                            onChange={(event, newValue) => {
                                                setUpdateTaskName(newValue);
                                            }}
                                            inputValue={updateTaskName}
                                            onInputChange={(event, newInputValue) => {
                                                setUpdateTaskName(newInputValue);
                                            }}
                                            id="controllable-states-demo"
                                            options={taskNameOptions}
                                            sx={{ width: 170 }}
                                            renderInput={(params) => <TextField {...params} />}
                                            disableClearable
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Task Number :
                                        </Typography>
                                        <input
                                            type="number"
                                            style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                            value={updateTaskNumber}
                                            onChange={(e) => setUpdateTaskNumber(e.target.value)}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Status :
                                        </Typography>
                                        <Select
                                            displayEmpty
                                            value={updateCustomerTaskStatusID}
                                            onChange={(e) => setUpdateCustomerTaskStatusID(e.target.value)}
                                            // sx={{width:"100%"}}
                                        >
                                            <MenuItem sx={{ width: '100%' }} value="">
                                                Select Status
                                            </MenuItem>
                                            {customerTasklistStatusList.map((item, index) => (
                                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </Grid>

                                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '16px',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            Is Package :
                                        </Typography>
                                        <Checkbox checked={updateIsPackage} onChange={(e) => setUpdateIsPackage(e.target.checked)} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Button
                            variant="contained"
                            sx={{
                                display: 'block',
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '50px'
                            }}
                            onClick={() => submitInsertTasklist()}
                            disabled={updateBtnDisabled}
                        >
                            Update
                        </Button>
                    </Box>
                )}
            </Modal>
        </>
    );
};

export default UpdateCustomerTasklistRecord;
